export default "__VITE_ASSET__Cs9F3SlG__"